export const custom = {
    email: {
        required: 'Email Address is required',
        email: 'Email address must be valid',
    },
    forgot_password_email: {
        required: 'Email Address is required',
        email: 'Email address must be valid',
    },
    old_password: {
        required: 'Old Password is required',
    },
    password: {
        required: 'Password is required',
        min: 'The password must be at least 8 characters'
    },
    confirm_password: {
        confirmed: 'Password is not the same',
        required: 'Confirm Password is required',
    },
    address: {
        required: 'Address is required',
    },
    plan_number: {
        required: 'Plan Number is required',
    },
    vault_name: {
        required: 'Vault Name is required',
    },
    property_type: {
        required: 'Property Type is required',
    },
    number_of_lots: {
        required: 'Number of Lots is required',
        numeric: 'Number of Lots must be valid',
    },
    first_name: {
        required: 'First Name is required',
    },
    last_name: {
        required: 'Last Name is required',
    },
    mobile_number: {
        required: 'Mobile Number is required',
        numeric: 'Mobile Number must be valid',
    },
    financial_institution: {
        required: 'Financial Institution is required',
    },
    account_name: {
        required: 'Account Name is required',
        min: 'Account Name must be at least 4 characters',
        max: 'Account Name may not be greater than 32 characters',
    },
    name_on_card: {
        required: 'Name on Card is required',
        min: 'Name on Card must be at least 3 characters',
        max: 'Name on Card may not be greater than 255 characters',
    },
    bsb: {
        required: 'BSB is required',
    },
    account_number: {
        required: 'Account Number is required',
        numeric: 'Account Number may only contain numeric characters',
        min: 'Account Number must be at least 4 digits',
        max: 'Account Number may not be greater than 10 digits',
    },
    credit_card_account_number: {
        required: 'Credit Card Number is required',
    },
    address: {
        required: 'Address is required',
        max: 'Address may not be greater than 255 characters',
    },
    country: {
        required: 'Country is required',
    },
    state: {
        required: 'State is required',
    },
    city: {
        required: 'City is required',
        max: 'City may not be greater than 75 characters',
    },
    postcode: {
        required: 'Post Code is required',
        min: 'Post Code must be at least 4 characters',
        max: 'Post Code may not be greater than 10 characters',
    },
    card_expiry: {
        required: 'Card Expiration is required'
    },
    invite_email: {
        required: 'Invitation Email is required',
        email: 'Email must be valid'
    },
    invite_title: {
        required: 'Title is required',
    },
    invite_first_name: {
        required: 'First Name is required',
    },
    invite_last_name: {
        required: 'Last Name is required',
    },
    invite_mobile_number: {
        required: 'Mobile Number is required',
    },
    invite_role: {
        required: 'Permission Profile is required',
    },
    start_date: {
        required: 'Start Date is required',
    },
    expiry_days: {
        required: 'Expiry Date is required',
    },
    filing_datestamp: {
        required: 'Date Stamp is required',
        date_format: 'Date Stamp must be in the format dd/mm/yyyy'
    },
    msg_title: {
        required: 'Title is required'
    },
    msg_body: {
        required: 'Message is required'
    },
    selected_users: {
        required: 'Please select atleast 1 recipient'
    },
    task_title: {
        required: 'Title is required',
        max: 'Title may not be longer than 250 characters'
    },
    description: {
        required: 'Description is required'
    },
    event_title: {
        required: 'Title is required'
    },
    assign_to: {
        required: 'Please select a User'
    },
    due_at: {
        required: 'Due Date is required',
        date_format: 'Due Date must be in the proper format'
    },
    reassign_to: {
        required: 'User is required',
    },
    title: {
        required: 'Title is required',
    },
    category_name: {
        required: 'Category name is required',
    },
    activity: {
        required: 'Primary business activity is required',
    },
    start_date: {
        required: 'Start date is required',
    },
    end_date: {
        required: 'End date is required',
    },
    recurring_end_date: {
        required: 'End date is required',
    }
};
